/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { useAlert } from 'react-alert'

import { ClinicsModel } from '../../../../../domain/models'

import { maskCep } from '../../../../utils'
import { Input } from '../../../../components'

import { IconTrashSvg } from '../../../../assets/icons/svgComponents'

import * as S from './styles'

const ClinicsCard = ({ defaultValue, onChangeComponent, onDelete }: any) => {
  const [data, setData] = useState<ClinicsModel>()
  const alert = useAlert()

  const checkCEP = (event: React.FocusEvent<HTMLInputElement>) => {
    const cep = event.target.value.replace(/\D/g, '')

    fetch(`https://viacep.com.br/ws/${cep}/json/`)
      .then((res) => res.json())
      .then((data) => {
        if (!data.erro) {
          setData((prev: any) => ({
            ...prev,
            endereco: {
              ...prev.endereco,
              logradouro: data.logradouro,
              bairro: data.bairro,
              cidade: data.localidade,
              uf: data.uf
            }
          }))
        } else {
          alert.show('Cep invalido. Tente novamente!', {
            type: 'error',
            timeout: 4000
          })
        }
      })
  }

  useEffect(() => {
    if (onChangeComponent && data) {
      onChangeComponent(data)
    }
  }, [data])

  useEffect(() => {
    if (defaultValue) {
      setData(defaultValue)
    }
  }, [])

  return (
    <S.InputAddressContainer>
      <button
        title="Deletar endereço"
        className="trash-button"
        type="button"
        onClick={() => onDelete()}
      >
        <IconTrashSvg />
      </button>
      <Input
        labelColor="#4F4F4F"
        label="Nome da clínica (opcional)"
        name="clinic"
        type="text"
        maxLength={100}
        onChange={(e: any) =>
          setData((prev: any) => ({
            ...prev,
            nomeClinica: e.target.value
          }))
        }
        value={data?.nomeClinica}
      />
      <Input
        labelColor="#4F4F4F"
        label="CEP"
        name="cep"
        type="text"
        maxLength={9}
        onChange={(e: any) =>
          setData((prev: any) => ({
            ...prev,
            endereco: {
              ...prev?.endereco,
              cep: e.target.value
            }
          }))
        }
        defaultValue={defaultValue?.endereco?.cep}
        value={maskCep(data?.endereco?.cep)}
        onBlur={checkCEP}
      />
      <Input
        labelColor="#4F4F4F"
        label="Rua"
        name="street"
        type="text"
        maxLength={100}
        onChange={(e: any) =>
          setData((prev: any) => ({
            ...prev,
            endereco: {
              ...prev.endereco,
              logradouro: e.target.value
            }
          }))
        }
        value={data?.endereco?.logradouro}
      />
      <Input
        labelColor="#4F4F4F"
        label="Número"
        name="number"
        type="text"
        maxLength={6}
        onChange={(e: any) =>
          setData((prev: any) => ({
            ...prev,
            endereco: {
              ...prev.endereco,
              numero: e.target.value
            }
          }))
        }
        value={data?.endereco?.numero}
      />
      <Input
        labelColor="#4F4F4F"
        label="Bairro"
        name="district"
        type="text"
        maxLength={100}
        onChange={(e: any) =>
          setData((prev: any) => ({
            ...prev,
            endereco: {
              ...prev.endereco,
              bairro: e.target.value
            }
          }))
        }
        value={data?.endereco?.bairro}
      />
      <Input
        labelColor="#4F4F4F"
        label="Complemento"
        name="complement"
        type="text"
        maxLength={100}
        onChange={(e: any) =>
          setData((prev: any) => ({
            ...prev,
            endereco: {
              ...prev.endereco,
              complemento: e.target.value
            }
          }))
        }
        value={data?.endereco?.complemento}
      />
      <Input
        labelColor="#4F4F4F"
        label="Cidade"
        name="city"
        type="text"
        maxLength={100}
        onChange={(e: any) =>
          setData((prev: any) => ({
            ...prev,
            endereco: {
              ...prev.endereco,
              cidade: e.target.value
            }
          }))
        }
        value={data?.endereco?.cidade}
      />
      <Input
        labelColor="#4F4F4F"
        label="Estado"
        name="state"
        type="text"
        autoComplete="off"
        onChange={(e: any) =>
          setData((prev: any) => ({
            ...prev,
            endereco: {
              ...prev.endereco,
              uf: e.target.value
            }
          }))
        }
        value={data?.endereco?.uf}
      />
    </S.InputAddressContainer>
  )
}

export default ClinicsCard
